import React from "react";
import { List, Card, Button, Avatar, Icon, Popconfirm, Rate } from "antd";
const { Meta } = Card;
export function TechnicalSkillsList({
  technicalSkills,
  item,
  showModal,
  deleteItem
}) {
  const confirm = (index,itemToDelete) => e => {
    deleteItem(index,itemToDelete);
  };

  return (
    <List
      grid={{
        gutter: 8,
        xs: 1,
      sm: 1,
      md: 1,
      lg: 3,
      xl: 3,
      xxl: 3,
      }}
      dataSource={[
        {},
        ...Object.keys(technicalSkills).map((el, index) => {
          return {
            cpWebsiteName:el,
            ...technicalSkills[el],
            index
          };
        })
      ]}
      renderItem={item => {
        if (item && item.cpWebsiteName) {
          return (
            <List.Item key={item.cpWebsiteName}>
              <Card
                
                actions={[
                  <Popconfirm
                    placement="bottom"
                    title="Are you sure delete this Profile?"
                    onConfirm={confirm(item.cpWebsiteName)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Icon type="delete" />
                  </Popconfirm>
                ]}
              >
                <Meta
                avatar={
                  <Avatar style={{ backgroundColor: ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae','#4CAF50','#03A9F4'][Math.floor(Math.random() * 5)], verticalAlign: 'middle' }} size="large" >{item.cpWebsiteName && ((item.cpWebsiteName).toString()).charAt(0)} </Avatar>
                }
                  title={item.cpWebsiteName}
                />

                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="user" />@ : {item.userName}{" "}
                </div>
              </Card>
            </List.Item>
          );
        }
        return (
          <List.Item>
            <Button onClick={showModal} type="dashed" className="sdd">
              <Icon type="plus" />
              Add External Profile
            </Button>
          </List.Item>
        );
      }}
    />
  );
}
